export const config = {
  isMosaic: false,
};
export default config;
